var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { baseApi } from "@madmedical/store";
const api = baseApi
    .enhanceEndpoints({
    addTagTypes: ["measurements"],
})
    .injectEndpoints({
    endpoints: (build) => ({
        getMeasurementList: build.query({
            query: (_a) => {
                var { userId } = _a, params = __rest(_a, ["userId"]);
                return ({
                    url: `collect/users/${userId}/measurements/list`,
                    params,
                });
            },
            serializeQueryArgs: ({ queryArgs }) => {
                const { page, pageSize } = queryArgs, args = __rest(queryArgs, ["page", "pageSize"]);
                return args;
            },
            merge: (cachedData, responseData) => {
                if (responseData.pagination.currentPage === 1) {
                    // Reset to first page
                    return responseData;
                }
                cachedData.items.push(...responseData.items);
                cachedData.pagination = responseData.pagination;
            },
            forceRefetch: ({ currentArg, previousArg }) => !currentArg ||
                !previousArg ||
                currentArg.page !== previousArg.page ||
                currentArg.pageSize !== previousArg.pageSize,
            providesTags: ["measurements"],
        }),
        getMeasurementRange: build.query({
            query: (_a) => {
                var { userId } = _a, params = __rest(_a, ["userId"]);
                return ({
                    url: `collect/users/${userId}/measurements/range`,
                    params,
                });
            },
            providesTags: ["measurements"],
        }),
        getAggregatedMeasurements: build.query({
            query: (_a) => {
                var { byPeriod } = _a, params = __rest(_a, ["byPeriod"]);
                return ({
                    url: `collect/measurements/aggregated/${byPeriod}`,
                    params,
                });
            },
            serializeQueryArgs: ({ queryArgs }) => {
                const { page, pageSize } = queryArgs, args = __rest(queryArgs, ["page", "pageSize"]);
                return args;
            },
            merge: (cachedData, responseData) => {
                if (responseData.pagination.currentPage === 1) {
                    // Reset to first page
                    return responseData;
                }
                cachedData.items.push(...responseData.items);
                cachedData.pagination = responseData.pagination;
            },
            forceRefetch: ({ currentArg, previousArg }) => !currentArg ||
                !previousArg ||
                currentArg.page !== previousArg.page ||
                currentArg.pageSize !== previousArg.pageSize,
            providesTags: ["measurements"],
        }),
        createManual: build.mutation({
            query: (_a) => {
                var { userId } = _a, body = __rest(_a, ["userId"]);
                return ({
                    url: `collect/users/${userId}/measurements`,
                    method: "POST",
                    body,
                });
            },
            invalidatesTags: ["measurements"],
        }),
        deleteMeasurement: build.mutation({
            query: (id) => ({
                url: `collect/measurements/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["measurements"],
        }),
    }),
});
export const { useGetMeasurementListQuery, useGetMeasurementRangeQuery, useCreateManualMutation, useGetAggregatedMeasurementsQuery, useDeleteMeasurementMutation, } = api;
